import { Modal } from 'react-bootstrap';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmModalStateProps {
  show: boolean;
  title: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmButtonClass?: string;
  modalSize?: 'xl' | 'lg' | 'sm' | undefined;
  cls?: string;
}

interface ConfirmModalDispatchProps {
  confirm: () => void;
  cancel: () => void;
  dismiss?: () => void;
}

const ConfirmModalDialog: React.FC<
  ConfirmModalStateProps & ConfirmModalDispatchProps
> = ({
  title,
  show,
  children,
  confirmLabel,
  cancelLabel,
  confirm,
  cancel,
  confirmButtonClass,
  dismiss,
  modalSize,
  cls = '',
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={dismiss ?? cancel}
      size={modalSize ?? undefined}
      className={`confirm-modal ${cls}`}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer className='text-right'>
        <button
          className={`btn btn-sm ${confirmButtonClass || 'btn-dark'}`}
          onClick={confirm}
        >
          {confirmLabel || t('confirmDialog_confirm', { uppercase: true })}
        </button>
        <button className='btn btn-light btn-sm cancel-btn' onClick={cancel}>
          {cancelLabel || t('confirmDialog_cancel', { uppercase: true })}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModalDialog;
